import translationKeys from '../../translations/keys';

// Safe access to translation keys with fallback
const partnerPortalKeys = translationKeys.partnerPortal || {};
const tabKeys = partnerPortalKeys.tabs || {};
const sideNavKeys = partnerPortalKeys.sideNav || {};
const PARTNER_PORTAL_GETTING_STARTED_PATH = '/partner-portal/getting-started';

export const PARTNER_PORTAL_DEFAULT_SECTION = 'partner-program';
export const PARTNER_PORTAL_START_PATH =
    `${PARTNER_PORTAL_GETTING_STARTED_PATH}?section=${PARTNER_PORTAL_DEFAULT_SECTION}`;

export const TABS = [
    {
        id: 'getting-started',
        label: 'Getting started',
        translationKey: tabKeys.GETTING_STARTED,
        path: PARTNER_PORTAL_GETTING_STARTED_PATH,
        sideNavItems: [
            { id: 'partner-program', label: 'Partner Program', translationKey: sideNavKeys.PARTNER_PROGRAM },
            { id: 'how-to-demo', label: 'How to demo', translationKey: sideNavKeys.HOW_TO_DEMO },
            { id: 'branding', label: 'Branding', translationKey: sideNavKeys.BRANDING },
            { id: 'certified-installers', label: 'Certified installers', translationKey: sideNavKeys.CERTIFIED_INSTALLERS },
            { id: 'billing', label: 'Billing', translationKey: sideNavKeys.BILLING },
        ]
    },
    {
        id: 'partner-details',
        label: 'Partner details',
        translationKey: tabKeys.PARTNER_DETAILS,
        path: '/partner-portal/partner-details',
        sideNavItems: [
            { id: 'partner-details', label: 'Partner details', translationKey: sideNavKeys.PARTNER_DETAILS },
        ]
    },
    {
        id: 'customers',
        label: 'Customers',
        translationKey: tabKeys.CUSTOMERS,
        path: '/partner-portal/customers',
        sideNavItems: [
            { id: 'customer-list', label: 'Customer list', translationKey: sideNavKeys.CUSTOMER_LIST, hideSideNav: true },
            { id: 'plan', label: 'Plan', translationKey: sideNavKeys.PLAN },
            { id: 'plan-history', label: 'Plan history', translationKey: sideNavKeys.PLAN_HISTORY },
            { id: 'cameras', label: 'Cameras', translationKey: sideNavKeys.CAMERAS },
        ]
    },
    {
        id: 'billing',
        label: 'Billing',
        translationKey: tabKeys.BILLING,
        path: '/partner-portal/billing',
        sideNavItems: [
            { id: 'billing-history', label: 'Current month', translationKey: sideNavKeys.CURRENT_MONTH },
            { id: 'invoices', label: 'Invoices', translationKey: sideNavKeys.INVOICES },
        ]
    },
    {
        id: 'materials',
        label: 'Materials',
        translationKey: tabKeys.MATERIALS,
        path: '/partner-portal/materials',
        sideNavItems: [
            { id: 'spec-sheets', label: 'Spec sheets', translationKey: sideNavKeys.SPEC_SHEETS },
            { id: 'install-guides', label: 'Install guides', translationKey: sideNavKeys.INSTALL_GUIDES },
            { id: 'marketing-material', label: 'Marketing material', translationKey: sideNavKeys.MARKETING_MATERIAL },
        ]
    },
    {
        id: 'pricing',
        label: 'Pricing',
        translationKey: tabKeys.PRICING,
        path: '/partner-portal/pricing',
        sideNavItems: [
            { id: 'pricing-tiers', label: 'Pricing tiers', translationKey: sideNavKeys.PRICING_TIERS },
        ]
    },
    {
        id: 'cloud-adapters',
        label: 'Cloud Adapters',
        translationKey: tabKeys.CLOUD_ADAPTERS,
        path: '/partner-portal/cloud-adapters',
        sideNavItems: [
            { id: 'adapter-models', label: 'Adapter models', translationKey: sideNavKeys.ADAPTER_MODELS },
        ]
    }
];

export const DEFAULT_TAB = TABS[0];
export const DEFAULT_SIDE_NAV_ITEM = DEFAULT_TAB.sideNavItems[0];
